module.exports = require("core-js-pure/stable/array/is-array");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/array/is-array.js
// module id = 587
// module chunks = 0